// extracted by mini-css-extract-plugin
export var hideEditor = "_ia-2";
export var infoIcon = "_ia-3";
export var label = "_ia-1";
export var labelContainer = "_ia-0";
export var readonlyText = "_ia-4";